module.exports = __webpack_public_path__ + "robots.txt";


//////////////////
// WEBPACK FOOTER
// ./src/robots.txt
// module id = 464
// module chunks = 0